import { TFunctionKeys } from '@/types/translations/types';
import { useTranslation } from 'next-i18next';
import translationFallbackUtil from '@/utilites/translations/translationFallback';

export default function useTypedTranslation<T extends string = string>(
  tKey: TFunctionKeys
): {
  translateWithFallback: (key: T, fallBack: string) => string;
  translate: (key: T) => string;
} {
  const { t } = useTranslation(tKey);

  const translationFallback = (translationName: T, fallback: string) => {
    return translationFallbackUtil(
      translationName,
      t(translationName),
      fallback
    );
  };

  const translate = (key: T) => t(key);

  return { translateWithFallback: translationFallback, translate };
}
